<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <card class="card-login card-white">
        <template slot="header">
          <img src="img/card-primary.png" alt="" />
          <h1 class="card-title">Log in</h1>
        </template>

        <div class="text-center mt-4">
          <div>
            <button class="btn btn-simple btn-twitter" @click="twitterSignIn">
              <i class="fab fa-twitter"></i> Se connecter avec Twitter
            </button>
          </div>
          <div>
            <button class="btn btn-simple btn-google" @click="googleSignIn">
              <i class="fab fa-google"></i> Se connecter avec Google
            </button>
          </div>
          <div>
            <button class="btn btn-simple btn-apple" @click="appleSignIn">
              <i class="fab fa-apple"></i> Se connecter avec Apple
            </button>
          </div>
      </div>

      <div slot="footer">
        <span class="mx-3">
            En poursuivant, vous acceptez les <router-link class="" tag="a" to="/terms">conditions d'utilisation</router-link>.
          </span>
      </div>
      </card>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
  methods: {
    twitterSignIn() {
      this.$store.dispatch('auth/signIn', 'Twitter')
    },
    googleSignIn() {
      this.$store.dispatch('auth/signIn', 'Google')
    },
    appleSignIn() {
      this.$store.dispatch('auth/signIn', 'Apple')
    },
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
